import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Index from "@/views/index.vue";
import software from "@/views/product/software.vue";
import hardware from "@/views/product/hardware.vue";
import AiVue from "@/views/product/ai.vue";
import Device from "@/views/product/device.vue";
import Home from "@/views/home/home.vue";
import Consult from "@/views/consult/index.vue";
import News from "@/views/news/news.vue";
import NewsDetail from "@/views/news/detail.vue";
import AboutUs from "@/views/aboutUs/index.vue";
import CooperativeEcosystem from "@/views/cooperativeEcosystem/index.vue";
import CustomerCase from "@/views/customerCase/customerCase.vue";
import CustomerCaseDetail from "@/views/customerCase/customerCaseDetail.vue";
import LaboratoryManagement from "@/views/solution/laboratoryManagement.vue";
import ChemicalControl from "@/views/solution/chemicalControl.vue";
import TrainingAdmission from "@/views/solution/trainingAdmission.vue";
import ResourceSharing from "@/views/solution/resourceSharing.vue";
import SafetyInspection from "@/views/solution/safetyInspection.vue";
import WasteDisposal from "@/views/solution/wasteDisposal.vue";
import WastewaterTreatment from "@/views/solution/wastewaterTreatment.vue";
import DigitalTwin from "@/views/solution/digitalTwin.vue";
import Success from "@/views/consult/success.vue";
import ProductDetail from "@/views/product/detail.vue";
import MoreDevice from "@/views/product/moreDevice.vue";
import DeviceDetail from "@/views/product/deviceDetail.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "index",
    redirect: "/home",
    component: Index,
    children: [
      {
        path: "home",
        name: "home",
        component: Home,
        meta: {
          title: "耀客物联：一站式AIoT平台，连接数据、设备与决策行业解决方案",
          fullWidth: true,
        },
      },
      {
        path: "consult",
        name: "consult",
        component: Consult,
        meta: {
          title: "耀客咨询服务-耀客明道物联网（武汉）有限公司",
          fullWidth: true,
        },
      },
      {
        path: "success",
        name: "success",
        component: Success,
        meta: {
          title: "耀客咨询-耀客明道物联网（武汉）有限公司",
        },
      },
      {
        path: "product",
        name: "product",
        children: [
          {
            path: "index",
            name: "productIndex",
            component: () => import("@/views/product/index.vue"),
            meta: {
              title: "耀客软件产品-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "software",
            name: "software",
            component: software,
            meta: {
              title: "耀客软件产品-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "hardware",
            name: "hardware",
            component: hardware,
            meta: {
              title: "耀客硬件产品-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "ai",
            name: "ai",
            component: AiVue,
            meta: {
              title: "耀客AI产品-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "device",
            name: "device",
            component: Device,
            meta: {
              title: "耀客设备产品-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "detail",
            name: "productDetail",
            component: ProductDetail,
            meta: {
              title: "耀客产品详情-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "moreDevice",
            name: "moreDevice",
            component: MoreDevice,
            meta: {
              title: "耀客更多产品-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "deviceDetail",
            name: "deviceDetail",
            component: DeviceDetail,
            meta: {
              title: "耀客设备详情-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
        ],
      },
      {
        path: "news",
        name: "news",
        children: [
          {
            path: "index",
            name: "newsIndex",
            component: News,
            meta: {
              title: "耀客新闻-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "detail",
            name: "detail",
            component: NewsDetail,
            meta: {
              title: "耀客新闻详情-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
        ],
      },
      {
        path: "solution",
        name: "Solution",
        meta: {
          title: "耀客解决方案-耀客明道物联网（武汉）有限公司",
        },
        children: [
          {
            path: "index",
            name: "solutionIndex",
            component: () => import("@/views/solution/index.vue"),
            meta: {
              title: "耀客解决方案-耀客明道物联网（武汉）有限公司",
              fullWidth: true,
            },
          },
          {
            path: "laboratoryManagement",
            name: "LaboratoryManagement",
            component: LaboratoryManagement,
            meta: {
              title: "耀客实验室管理-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "chemicalControl",
            name: "ChemicalControl",
            component: ChemicalControl,
            meta: {
              title: "耀客化学品管控-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "trainingAdmission",
            name: "TrainingAdmission",
            component: TrainingAdmission,
            meta: {
              title: "耀客培训准入-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "resourceSharing",
            name: "ResourceSharing",
            component: ResourceSharing,
            meta: {
              title: "耀客资源共享-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "safetyInspection",
            name: "SafetyInspection",
            component: SafetyInspection,
            meta: {
              title: "耀客安全巡检-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "wasteDisposal",
            name: "WasteDisposal",
            component: WasteDisposal,
            meta: {
              title: "耀客危废处理-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "wastewaterTreatment",
            name: "WastewaterTreatment",
            component: WastewaterTreatment,
            meta: {
              title: "耀客废水处置-耀客明道物联网（武汉）有限公司",
            },
          },
          {
            path: "digitalTwin",
            name: "DigitalTwin",
            component: DigitalTwin,
            meta: {
              title: "耀客数字孪生-耀客明道物联网（武汉）有限公司",
            },
          },
        ],
      },
      {
        path: "customerCase",
        name: "CustomerCase",
        component: CustomerCase,
        meta: {
          title: "耀客客户案例-耀客明道物联网（武汉）有限公司",
          fullWidth: true,
        },
      },
      {
        path: "customerCaseDetail",
        name: "CustomerCaseDetail",
        component: CustomerCaseDetail,
        meta: {
          title: "耀客客户案例详情-耀客明道物联网（武汉）有限公司",
        },
      },
      {
        path: "cooperativeEcosystem",
        name: "CooperativeEcosystem",
        component: CooperativeEcosystem,
        meta: {
          title: "耀客合作生态-耀客明道物联网（武汉）有限公司",
          fullWidth: true,
        },
      },
      {
        path: "aboutUs",
        name: "AboutUs",
        component: AboutUs,
        meta: {
          title: "耀客关于我们-耀客明道物联网（武汉）有限公司",
          fullWidth: true,
        },
      },
    ],
  },
  {
    path: "/:pathMath(.*)",
    redirect: "/home",
  },
];

const router = createRouter({
  // hash模式的路由
  history: createWebHashHistory(),
  // history模式
  // history: createWebHistory(),
  routes,
});

// 路由拦截，形成进度条
router.beforeEach((to, from, next) => {
  // 标题
  document.title = String(to.meta?.title || "耀客物联");
  next();
});

router.afterEach(() => {
  // 置顶
  window.scrollTo(0, 0);
});

export default router;
